import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { bootstrapWireClient } from '../bootstrap';
import { ChannelList } from './ChannelList';
import { DmSidebar } from './DmSidebar';
import { MainPane } from './MainPane';
import { ServerRail } from './ServerRail';
import styles from './shell.module.css';

export function Shell(): JSX.Element {
  const location = useLocation();
  const worldId = (location.state as { worldId?: number } | null)?.worldId;
  const teardownRef = useRef<(() => void) | null>(null);
  const bootstrappedRef = useRef(false);

  useEffect(() => {
    if (bootstrappedRef.current) return;
    bootstrappedRef.current = true;

    void bootstrapWireClient(worldId ?? undefined).then((teardown) => {
      teardownRef.current = teardown;
    });

    return () => {
      teardownRef.current?.();
      teardownRef.current = null;
      bootstrappedRef.current = false;
    };
  }, [worldId]);

  return (
    <div className={styles.shell}>
      <ServerRail />
      <ChannelList />
      <MainPane />
      <DmSidebar />
    </div>
  );
}
